import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import "../salestarget.css";
import { useLocation } from "react-router-dom";
import BASEURL from "../../Utils/Baseurl";
import {
  getSalestargetDetailByMaster,
  getSalestargetDetailByUser,
} from "../grphql";
import { useAuth } from "../../../context/AuthContext/AuthContextProvider";
import request from "graphql-request";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

const EmployeeViewTarget = () => {
  const [data, setData] = useState([]);
  const { currentUser } = useAuth();
  const isUser = currentUser?.role;
  const location = useLocation();
  const pathid = location.search.slice(1);

  useEffect(() => {
    const fetchdata = async () => {
      try {
        const res = await request(
          BASEURL,
          isUser.toLowerCase() == "manager"
            ? getSalestargetDetailByMaster
            : getSalestargetDetailByUser,
          {
            id: pathid,
          }
        );

        setData(
          isUser.toLowerCase() == "manager"
            ? res?.getSalestargetDetailByMaster
            : res?.getSalestargetDetailByUser
        );
      } catch (err) {
      } finally {
      }
    };
    fetchdata();
  }, [pathid]);
  return (
    <DashboardLayout>
      {data?.map((v, i) => {
        return (
          <div key={i}>
            <div>
              <table className="montable">
                <thead>
                  <tr className="montr">
                    <th className="month">Employee Name</th>
                    <th className="month">Financial Year</th>
                    <th className="month">Target Amount</th>
                  </tr>
                </thead>
                <tbody className="month">
                  <tr className="montr" key={i}>
                    <td className="montd">{v.user?.username}</td>
                    <td className="montd">{v.salesTarget?.financialYear}</td>
                    <td className="montd">{v.targetAmount}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="tabel-target">
              <table>
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Month</th>
                    <th>Target Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {v.monthlytargetSet?.map((row, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{row.monthYear}</td>
                        <td
                          style={{
                            display: "flex",
                            marginTop: "5px",
                            alignItems: "center",
                          }}
                        >
                          {row.targetAmount || 0}

                          <CurrencyRupeeIcon sx={{ marginLeft: "10px" }} />
                        </td>
                      </tr>
                      
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </DashboardLayout>
  );
};

export default EmployeeViewTarget;
